import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { LayoutContext } from 'components/app-routes';
import MobileFooterLayout from 'components/old-footer-layout';
import Footer from 'components/footer';
import { redirectToHome } from '__utils/common-utils';
import { OltagTypeItem,TermsConditionsConstantsItems,TermsConditionsList } from './termsconditionsconstants';

const TermsConditions: React.FC = () => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

	useEffect(() => {
		SetLayoutProps({
			config: {
				goBackCallback: () => redirectToHome(),
				title: <span>TERMS OF USE</span>,
			},
			showBseInfoForDesktop: false,
			showCopyrightInfoForDesktop: true,
			breadcrumbList:[{text:'Home',url:'v1/home', isExternal:true},{text:'Terms of Use',url:''}]
		});
	}, []);
	return(
		<>
		<div className="outercontainer">
		</div>
		<div className={!isMobile ? 'innerContainer' : ''}>
		{!isMobile && (
					<section className="staticPageHead group">
						<h1>TERMS OF USE</h1>
					</section>
				)}
		<div className={!isMobile ? '' : 'aboutUS staticPg px-card'}>
			<div className={!isMobile ? '' : 'singleAbout'}>
				<section className={
								!isMobile ? 'staticPage' : 'container-fluid'
							}>
				<p>
								<strong>Date of Publication:</strong> 13th
								Feb 2019
								<br />
								<strong>Last Amended on:</strong> 27th January 
								2024
				</p>
				<br />
				{TermsConditionsList.map((item:TermsConditionsConstantsItems,id:number)=>
				<div key={id}>
				 <h2>{item.h2tag}</h2>
				 {item?.ptag && item.ptag.map((item,id:number)=>
				 <p dangerouslySetInnerHTML={{ __html: item}} key={id}></p>)}
				 {item?.oltagtype && <ol type='a'>
					{item.oltag?.map((item:OltagTypeItem,id:number)=>
					<li key={id}>
						<div dangerouslySetInnerHTML={{ __html: item.point}}></div>
					<>{item?.oltagsubtype && <ol type={item.oltagsubtype}>
						{item?.subpoints && item.subpoints.map((item,id:number)=>
						<li dangerouslySetInnerHTML={{ __html: item}} key={id}></li>)}</ol>}</>
					</li>
					)}
				 </ol>
				 }
				
				</div>)}
				<p>
								It is possible those other users (including
								unauthorized users or &quot;hackers&quot;) may
								post or transmit offensive or obscene materials
								on the Website and that You may be involuntarily
								exposed to such offensive and obscene materials.
								It also is possible for others to obtain
								personal information about You due to your use
								of the Website, and that the recipient may use
								such information to harass or injure You.
								Turtlemint Money does not approve of such
								unauthorized uses, but by using the Website You
								acknowledge and agree that We are not
								responsible for the use of any personal
								information that You publicly disclose or share
								with others on the Website. Please carefully
								select the type of information that You publicly
								disclose or share with others on the Website.
							</p>

				</section>
			</div>
		</div>
		</div>
		 		{isMobile && (
				<Footer>
					<MobileFooterLayout />
				</Footer>
			)}
		</>
	);
};

export default TermsConditions;
